<div class="h-min-full yellow-bg d-flex flex-column align-items-center justify-content-center">
		<app-subscribe-search class="d-block m-2 white-bg rounded-xl"
		[mode]="'window'" 
		[source]="'external'"
		[params]="searchParams">
		</app-subscribe-search>
</div>